module.exports = __webpack_public_path__ + "img/3.c732549c.jpg";